(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSitePartKey', PublicSitePartKey);

    PublicSitePartKey.$inject = ['$resource'];

    function PublicSitePartKey ($resource) {
        var resourceUrl =  'api/public-site-part-keys/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
